export type RequirementCheck = 'any' | 'none'

export type RequirementConfig = {
  config: {
    variable: string
    values: string[]
  }
  check?: RequirementCheck // all doesn't make sense here
}

export type Requirements = RequirementConfig[]
